// Entry point for the build script in your package.json
// import "@hotwired/turbo-rails"
import "./controllers"
import "./add_jquery"
import { } from "jquery-ujs"
import "./jquery-ui" // To add or remove jquery-ui features go to https://jqueryui.com/download/ and select the features you want to add, then download the archive and extract jquery-ui.js and jquery-ui.css from the extracted folder
import "bootstrap/dist/js/bootstrap"
import "./adminlte/app"
import "./adminlte/fastclick.min"
import "./adminlte/jquery.slimscroll.min"
import "./adminlte/jquery.inputmask.bundle"
import "select2"
import "./redactor/redactor"
import "./cocoon"
import "./custom_field_room"
import "./runtime"
import 'leaflet'